<template>
  <div class="relative">
    <button @click="toggleDropdown" @blur="closeDropdown"
      class="px-4 py-1 rounded-full text-base font-semibold transition bg-white text-thenti-700 border border-thenti-700 hover:bg-thenti-50 flex items-center gap-2">
      <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" />
      </svg>
      {{ $t('common.language') }}
      <svg class="w-4 h-4 transition-transform duration-200" :class="{ 'rotate-180': isOpen }" fill="none"
        stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 7-7-7"></path>
      </svg>
    </button>

    <div v-if="isOpen"
      class="absolute top-full left-0 mt-1 bg-white border border-thenti-700 rounded-lg shadow-lg z-10 min-w-full">
      <button v-for="language in languages" :key="language.code" @mousedown="selectLanguage(language.code)"
        class="w-full px-4 py-2 text-left text-base font-semibold hover:bg-thenti-50 transition first:rounded-t-lg last:rounded-b-lg"
        :class="{ 'bg-thenti-50 text-thenti-700': language.code === locale }">
        {{ language.label }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { computed, onMounted, ref } from 'vue'

const { locale } = useI18n()
const isOpen = ref(false)

const languages = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  // { code: 'fr', label: 'Français' },
  // { code: 'it', label: 'Italiano' },
]

onMounted(() => {
  const savedLang = localStorage.getItem('site-lang-pref')
  if (savedLang && languages.some(l => l.code === savedLang)) {
    locale.value = savedLang
  } else {
    locale.value = 'en'
  }
})

function toggleDropdown() {
  isOpen.value = !isOpen.value
}

function closeDropdown() {
  // Small delay to allow mousedown event to fire before closing
  setTimeout(() => {
    isOpen.value = false
  }, 150)
}

function selectLanguage(code) {
  locale.value = code
  localStorage.setItem('site-lang-pref', code)
  isOpen.value = false
}

</script>